var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @desc measure text width
 */
import LRUMap from '@byted/light-render/lib/utils/LRU';
import { getContext } from '@byted/light-render/lib/utils/measureText';
import RichObj from '@byted/light-render/lib/RichText/rich-obj';
import { isRichFormat } from '../rich';
var textSizeLRUMap = new LRUMap(1000);
function measurePlainText(text, textStyle) {
    var ctx = getContext();
    var _a = textStyle.fontSize, fontSize = _a === void 0 ? 12 : _a, _b = textStyle.fontFamily, fontFamily = _b === void 0 ? 'sans-serif' : _b, _c = textStyle.fontWeight, fontWeight = _c === void 0 ? 'normal' : _c, _d = textStyle.fontStyle, fontStyle = _d === void 0 ? 'normal' : _d;
    ctx.save();
    if (typeof ctx.setFontSize === 'function') {
        ctx.setFontSize(fontSize);
    }
    else {
        ctx.font = fontStyle + " " + fontWeight + " " + fontSize + "px " + fontFamily + " ";
    }
    var width = ctx.measureText(text).width;
    ctx.restore();
    return { width: width, height: fontSize };
}
function measureRichText(text, textStyle) {
    var content = isRichFormat(text) ? text.content : text;
    var richObj = new RichObj(__assign({ text: content }, textStyle));
    richObj.layout();
    return richObj.getBoxSize();
}
export default function measureText(text, textStyle) {
    var _a;
    var _b = textStyle.fontSize, fontSize = _b === void 0 ? 12 : _b, _c = textStyle.rich, rich = _c === void 0 ? false : _c;
    var cacheKey = [text, fontSize, rich].join('__split__');
    var size = textSizeLRUMap.get(cacheKey);
    if (size) {
        return size;
    }
    if (textStyle.rich || isRichFormat(text)) {
        var richType = ((_a = text) === null || _a === void 0 ? void 0 : _a.RICH_TYPE) || textStyle.rich;
        if (richType === 'jsx' || richType === 'html') {
            size = { width: 0, height: textStyle.fontSize };
        }
        else {
            size = measureRichText(text, textStyle);
        }
    }
    else {
        size = measurePlainText(text, textStyle);
    }
    if (!isRichFormat(text)) {
        textSizeLRUMap.set(cacheKey, size);
    }
    return size;
}
